<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal"
            @OnClickConfermaModal="OnClickConfermaModal">

    <template v-slot:Body>
      
      <div style="display:flex; margin-bottom: 2%; justify-content: flex-end">
        <div class="col-md-12" v-if="NomeModelloDaCaricare != ''">
          <div style="float:left;width:3%;">&nbsp;</div>
          <label style="font-size:12px;margin-top: 1.9%;" class="ZMFormLabelSuccess">{{ NomeModelloDaCaricare + ' ' +  this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_CARICATO',this.LinguaUtente) }}</label>
        </div>
        <div class="col-md-12" v-else>
          <div style="float:left;width:3%;">&nbsp;</div>
        </div>
        <button @click="OnClickAggiungiModello" type="button" class="btn btn-success" style="width:30%">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI_NUOVO',this.LinguaUtente) }}</button>
      </div>


      <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
        <thead style="background-color:#60604d;color:white">
          <tr>
            <th width="65%">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</th>
            <th width="10%">{{ this.GetTraduzioneLabel('Generic','TKN_DEFAULT',this.LinguaUtente) }}</th>  
            <th width="10%">{{ this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_AZIONI',this.LinguaUtente) }}</th>                              
          </tr>
        </thead>
        <tbody :style="{'background-color' : Arancione}">
          <tr v-for="(Modello, Chiave) in LsModelli" :key="Modello.ChiaveModello">
            <td style="vertical-align:middle">{{ Modello.NomeConfigModello }}</td>
            <td style="vertical-align:middle">{{ Modello.IsDefaultModello ? this.GetTraduzioneLabel('Generic','TKN_SI',this.LinguaUtente) : this.GetTraduzioneLabel('Generic','TKN_NO',this.LinguaUtente) }}</td>

            <td style="vertical-align:middle;text-align:center;">
              <i class="fa fa-upload text-info ZMIconButton" :title="this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_IMPOSTA_DEFAULT',this.LinguaUtente)" @click="ApriPopupCambioDefaultModello(Chiave)" style="margin-right:10px"></i>
              <i class="fa fa fa-save text-primary ZMIconButton" :title="this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_SOVRASCRIVI',this.LinguaUtente)" @click="OnClickSovrascriviCurrentModello(Chiave)" style="margin-right:10px"></i>
              <i class="fa fa-undo text-warning ZMIconButton" :title="this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_CARICA_MODULO',this.LinguaUtente)" @click="OnClickCaricaCurrentModello(Chiave)" style="margin-right:10px"></i>
              <i class="fa fa-trash-o text-danger ZMIconButton" :title="this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_ELIMINA',this.LinguaUtente)" @click="OnClickEliminaCurrentModello(Chiave)" style="margin-right:10px"></i>
            </td>

          </tr>
        </tbody>
      </table>

    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>

  <VUEPopupNomeModulo v-if="PopupNomeModulo" 
                            :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_NOME_MODULO',this.LinguaUtente) + ']'" 
                            :AltezzaPopup="AltezzaPopup" 
                            @OnClickConfermaPopup="OnClickConfermaPopupNomeModulo"
                            @OnClickChiudiPopup="OnClickChiudiPopupNomeModulo"/>
                            
  <VUEConfirm :Popup="PopupCambioDefaultModello" 
              :Richiesta="RichiestaEliminazioneDefault" 
              :PathLogo="require('@/assets/images/LogoDMS.png')" 
              :Programma="'DMSEW'" 
              @OnClickConfermaPopup="OnClickIsDefaultCurrentModello" @OnClickChiudiPopup="ChiudiPopupCambioDefaultModello">
  </VUEConfirm>

</template>

<script>  

import VUEModal from '@/utils/VUEModal.vue';            
import VUEConfirm from '@/utils/VUEConfirm.vue';            
import { SystemInformation, COLORI_PANTONE} from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEPopupNomeModulo from '../../components/Popups/VUEPopupNomeModulo.vue';

export default 
{
  data()
  {
   return {
            LinguaUtente                 : SystemInformation.UserInformation.Lingua,
            Arancione                    : COLORI_PANTONE.Arancione,
            LsModelli                    : {},
            ObjModelloDaCaricare         : null,
            NomeModelloDaCaricare        : '',
            RichiestaEliminazioneDefault : '',
            PopupNomeModulo              : false,
            PopupCambioDefaultModello    : false,
            IndiceModelloDefault         : null,
            LsChiaviDaEliminare          : [],
            ChiaveDefault                : -1,
            IndiceModelloInModifica      : -2
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjModulo', 'ObjListaModelli'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEConfirm,
                VUEPopupNomeModulo
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickConfermaModal()
    {
      this.$emit('OnClickConfermaPopup', this.LsModelli, this.LsChiaviDaEliminare, this.ChiaveDefault, this.ObjModelloDaCaricare, this.NomeModelloDaCaricare)
    },

    OnClickConfermaPopupNomeModulo(NomeModulo)
    {
      if(this.IndiceModelloInModifica == -1)
      {
        let NewModello = {}
        NewModello.JSONConfigModello = this.ObjModulo
        NewModello.NomeConfigModello = NomeModulo
        NewModello.ChiaveModello = -1
        NewModello.IsDefaultModello = false
        this.LsModelli.push(NewModello)
      }
      else
      {
        this.LsChiaviDaEliminare.push(this.LsModelli[this.IndiceModelloInModifica].ChiaveModello)
        this.LsModelli[this.IndiceModelloInModifica].JSONConfigModello = this.ObjModulo
        this.LsModelli[this.IndiceModelloInModifica].NomeConfigModello = NomeModulo
        this.LsModelli[this.IndiceModelloInModifica].ChiaveModello = -1
        this.LsModelli[this.IndiceModelloInModifica].IsDefaultModello = false
      }

      this.PopupNomeModulo = false
    },

    OnClickChiudiPopupNomeModulo()
    {
      this.PopupNomeModulo     = false
      this.IndiceModelloInModifica = -2
    },

    OnClickEliminaCurrentModello(Indice)
    {
      if(this.LsModelli[Indice].ChiaveModello != -1)
        this.LsChiaviDaEliminare.push(this.LsModelli[Indice].ChiaveModello)
      this.LsModelli.splice(Indice, 1)
    },

    ApriPopupCambioDefaultModello(Indice)
    {
      this.RichiestaEliminazioneDefault = this.GetTraduzioneLabel('VUEPopupImpostazioniModulo','TKN_CHANGE_DEFAULT',this.LinguaUtente)
      this.IndiceModelloDefault         = Indice
      this.PopupCambioDefaultModello    = true
    },

    ChiudiPopupCambioDefaultModello()
    {
      this.IndiceModelloDefault      = null
      this.PopupCambioDefaultModello = false
    },

    OnClickIsDefaultCurrentModello()
    {
      let Indice = this.IndiceModelloDefault
      if(Indice != null)
      {
        this.ChiaveDefault = this.LsModelli[Indice].ChiaveModello
        this.LsModelli.forEach((Modulo, i) => {Modulo.IsDefaultModello = (i == Indice) ? true : false})
      }
      this.ChiudiPopupCambioDefaultModello()
    },

    OnClickSovrascriviCurrentModello(Indice)
    {
      this.IndiceModelloInModifica = Indice
      this.PopupNomeModulo = true
    },

    OnClickCaricaCurrentModello(Indice)
    {
      this.ObjModelloDaCaricare  = this.LsModelli[Indice].JSONConfigModello
      this.NomeModelloDaCaricare = this.LsModelli[Indice].NomeConfigModello
    },

    OnClickAggiungiModello()
    {
      this.IndiceModelloInModifica = -1
      this.PopupNomeModulo = true
    }
  },

  watch:
  {
  },

  beforeMount()
  {
    this.LsModelli = structuredClone(this.ObjListaModelli)
    this.LsModelli.forEach(Elemento => { Elemento.IsDefaultModello ? this.ChiaveDefault = Elemento.ChiaveModello : false });
  }
  
}
</script>